import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-main-table-rotation-dialog',
  templateUrl: './main-table-rotation-dialog.component.html',
  styleUrls: ['./main-table-rotation-dialog.component.scss'],
  standalone: false,
})
export class MainTableRotationDialogComponent implements OnInit, OnDestroy {
  private readonly dialogRef = inject(MatDialogRef<MainTableRotationDialogComponent>);
  private readonly subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      fromEvent(window, 'resize').subscribe(() => {
        if (window.innerWidth > window.innerHeight) {
          this.dialogRef.close(true);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
